/**
 * Imported, for its side effect, by modules that fetch while the page
 * hydrates. It puts the Dash0 SDK back into the importing page's preloaded
 * JavaScript, so ~/lib/rum starts RUM before hydrateRoot: only a fetch the SDK
 * has wrapped gets a span and a traceparent.
 */
import { addSignalAttribute, init, reportError } from '@dash0/sdk-web';
import { preloadedSdk } from '~/lib/rum';

preloadedSdk({ init, addSignalAttribute, reportError });
